import { defineStore } from 'pinia';

export default defineStore({
  id: 'language',
  state: () => ({
    locale: String,
  }),
  actions: {
    setLocale(locale) {
      this.locale = locale || 'en';

      if (!this.locale) {
        localStorage.removeItem('hub-facilitator-portal-locale');
        return;
      }

      localStorage.setItem('hub-facilitator-portal-locale', this.locale);
    },
  },
});
